// The CI frontend build doesn't set TESTS, so E2E runs are recognized by
// navigator.webdriver, which Selenium's Chrome sets.
export const isAutomatedBrowser = !!(
  (process.env.TESTS && JSON.parse(process.env.TESTS)) ||
  (typeof navigator !== "undefined" && navigator.webdriver)
)
